export default {
  init() {
    // JavaScript to be fired on all pages
    var coll = document.getElementsByClassName('question-text');
    var i;

    for (i = 0; i < coll.length; i++) {
      var content = coll[i].nextElementSibling;
      $(content).hide();
      coll[i].addEventListener('click', function() {
        this.classList.toggle('active');
        content = this.nextElementSibling;
        $(content).slideToggle();
        // if (content.style.maxHeight){
        //   content.style.maxHeight = null;
        //   content.style.padding = null;
        // } else {
        //   content.style.maxHeight = (content.scrollHeight + 40) + 'px';
        // }
      });
    }

    $('.question-group').hide();

    $( document ).ready(function() {
      $('.question-section').first().addClass('active');
      $('#container-id-1').show().siblings().hide();
    });

    $('.question-section p').click(function() {
      $(this).parent().addClass('active').siblings().removeClass('active');
    });

    $('.question-section p').click(function() {
      var id = this.id;
      var ids = '[id=container-id-' + id + ']'

      $(ids).show(500).siblings().hide(500);
    });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/frequentlyAskedQuestions.js